import { type RefObject, useEffect, useMemo } from 'react'

const MERGE_FIELD_TOKEN = /\{[^{}]*\}/g

const countTokensInLinks = (root: HTMLElement) =>
  Array.from(root.querySelectorAll('a')).reduce(
    (total, link) => total + (link.textContent?.match(MERGE_FIELD_TOKEN)?.length ?? 0),
    0
  )

export const useMergeFieldsCount = <Node extends HTMLElement>(
  ref: RefObject<Node>,
  setCount: (count: number) => void
) => {
  const observer = useMemo(
    () =>
      new MutationObserver(() => {
        const root = ref.current

        if (!root) {
          setCount(0)
          return
        }

        const count = root.querySelectorAll('.mergeField-wrap').length + countTokensInLinks(root)

        setCount(count)
      }),
    [setCount]
  )

  useEffect(() => {
    if (ref.current) observer.observe(ref.current, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
      setCount(0)
    }
  }, [observer, setCount])
}
